import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Application } from '@fides/fides-react-components';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';
import { PrivateRoute } from '../helpers';

const Clients = React.lazy(() => import('../../components/pages/Client'));
const PendingApprovals = React.lazy(() => import('../../components/pages/PendingApprovals'));
const PendingApprovalDetails = React.lazy(() => import('../../components/pages/PendingApprovalDetails'));

export const AdministrationRouter = () => {
  const { accessHelper, twoMRHelper } = useGlobalConfigContext();
  const hasAccessToClients =
    !accessHelper.isImpersonated &&
    (accessHelper.isFidesAdministrator(Application.EFTWEB) ||
      accessHelper.isFidesReadOnlyAdministrator(Application.EFTWEB));
  const hasAccessToApprovals =
    twoMRHelper.is2MREnabled &&
    (twoMRHelper.hasUserAccessToActive2MRModule ||
      (accessHelper.isImpersonatedAsClient && twoMRHelper.is2MREnabledForAnyModule));

  return (
    <Switch>
      <Redirect from='/administration/' to='/administration/client' exact />
      <PrivateRoute path='/administration/client' exact>
        {hasAccessToClients ? <Clients /> : <Redirect to='/page-not-found' />}
      </PrivateRoute>
      <PrivateRoute path='/administration/pending-approvals' exact>
        {hasAccessToApprovals ? <PendingApprovals /> : <Redirect to='/page-not-found' />}
      </PrivateRoute>
      <PrivateRoute path='/administration/pending-approvals/:uniqueId' exact>
        {hasAccessToApprovals ? <PendingApprovalDetails /> : <Redirect to='/page-not-found' />}
      </PrivateRoute>
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
